import accountsDsps from './accountsDsps'
import audience from './audience'
import behavioral from './behavioral'
import browser from './browser'
import cclone from './cclone'
import customTaxonomies from './customTaxonomies'
import crm from './crm'
import data from './data'
import dataEntry from './dataEntry'
import demographic from './demographic'
import device from './device'
import dsp from './dsp'
import geography from './geography'
import georadar from './georadar'
import isp from './isp'
import media from './media'
import os from './os'
import secondParty from './secondParty'
import settings from './settings'
import tag from './tag'
import taxonomies from './taxonomies'
import transfer from './transfer'
import sharedAudience from './sharedAudience'

const state = {}

export default {
    namespaced: true,
    state,
    modules: {
        accountsDsps,
        audience,
        behavioral,
        browser,
        cclone,
        customTaxonomies,
        crm,
        data,
        dataEntry,
        demographic,
        device,
        dsp,
        geography,
        georadar,
        isp,
        media,
        os,
        secondParty,
        settings,
        tag,
        taxonomies,
        transfer,
        sharedAudience
    }
}
